// Build logo URL from brand label using files in /public/assets/logos
// Text variant:    /assets/logos/<brand>.png
// NoText variant:  /assets/logos/notext/<brand>.png
// Fallbacks:       /assets/logos/other.png, /assets/logos/notext/other.png

// Compute an effective prefix: use PUBLIC_URL only if the current URL path
// actually lives under that subpath (works in dev and prod).
const RAW_PREFIX = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
function getEffectivePrefix() {
  if (!RAW_PREFIX || RAW_PREFIX === "/") return "";
  try {
    const path = typeof window !== "undefined" ? window.location.pathname : "";
    if (path === RAW_PREFIX || path.startsWith(RAW_PREFIX + "/")) return RAW_PREFIX;
  } catch (_) {}
  return "";
}
const PREFIX = getEffectivePrefix();
const FALLBACK_TEXT = `${PREFIX}/assets/logos/other.png`;
const FALLBACK_NOTEXT = `${PREFIX}/assets/logos/notext/other.png`;

// Map normalized brand -> actual filename base, if your files use a different spelling
const FILE_ALIASES = {
  // Example: if your on-disk file is peugot.png
  "peugeot": "peugot",
  "mercedes-benz": "mercedes",
  "rolls-royce": "rolls",
  "land-rover": "rover",
  "general-motors": "gm",
};

function firstToken(label = "") {
  // Accept null/undefined and non-strings gracefully
  const str = typeof label === 'string' ? label : (label == null ? '' : String(label));
  // Take the first word before any space, "/" or ","
  return (str.split(/[\s/,]+/)[0] || "").trim();
}

export function normalizeBrand(label = "") {
  const primary = firstToken(label)
    .toLowerCase()
    .normalize("NFD").replace(/\p{Diacritic}/gu, "") // citroën -> citroen
    .replace(/[^a-z0-9]+/g, "-")                     // keep a-z 0-9 and dashes
    .replace(/^-+|-+$/g, "");                        // trim dashes

  return FILE_ALIASES[primary] || primary;
}

/**
 * Get logo URL under /public
 * @param {string} label   Raw brand string (e.g., "KIA/HYUNDAI", "PEUGOT/CITROËN")
 * @param {"text"|"noText"} variant
 * @returns {string} URL
 */
export function getBrandLogoUrl(label, variant = "noText") {
  const base = normalizeBrand(label);
  if (!base) return variant === "noText" ? FALLBACK_NOTEXT : FALLBACK_TEXT;

  if (variant === "noText") {
    return `${PREFIX}/assets/logos/notext/${base}.png`;
  }
  // "text" variant
  return `${PREFIX}/assets/logos/${base}.png`;
}

export function getBrandFallback(variant = "noText") {
  return variant === "noText" ? FALLBACK_NOTEXT : FALLBACK_TEXT;
}
